import { AlertService } from './../../shared/services/alert.service';
import { LocalStorageService } from './../../shared/services/loca-storage.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { MenuService } from '../../shared/services/menu.service';


@Injectable()
export class PermissionGuard implements CanActivateChild {
  constructor(private _localStorageService: LocalStorageService,
    private _alertService: AlertService,
    private _menuServices : MenuService
  ) { }
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        
        let ind_permission = this._menuServices.validate_permision(state.url);
        if(!ind_permission){
            this._alertService.openSwal(
                {
                  text : 'Lo sentimos su contrato no posee permisos para esta acción.',
                  type : 'warning'
                }
              );
        }
        return ind_permission;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/guards/permission.guard.ts